(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const sync = (frame, value) => {
      const next = Number(value);
      frame.style.setProperty('--position', `${next}%`);
      frame.dataset.edge = next < 18 ? 'start' : next > 82 ? 'end' : 'mid';
    };

    const revealFrame = (frame) => {
      if (!frame || frame.dataset.revealed === 'true') return;
      frame.dataset.revealed = 'true';
      const range = frame.querySelector('[data-compare-range]');
      if (!range) return;
      const target = Number(range.value);
      const shouldReveal = frame.dataset.revealSlider === 'true' && !reduceMotion.matches;
      if (!shouldReveal) {
        sync(frame, target);
        return;
      }
      const start = Math.max(14, target - 34);
      range.value = String(start);
      sync(frame, start);
      requestAnimationFrame(() => {
        frame.classList.add('is-revealing');
        range.value = String(target);
        sync(frame, target);
      });
      const settle = () => frame.classList.remove('is-revealing');
      frame.addEventListener('transitionend', settle, { once: true });
      window.setTimeout(settle, 1200);
    };

    const observe = (root) => {
      const frames = root.querySelectorAll('[data-compare]:not([data-compare-ready])');
      if (!frames.length) return;
      const io =
        'IntersectionObserver' in window
          ? new IntersectionObserver(
              (entries, observer) => {
                entries.forEach((entry) => {
                  if (!entry.isIntersecting) return;
                  revealFrame(entry.target);
                  observer.unobserve(entry.target);
                });
              },
              { threshold: 0.4 }
            )
          : null;

      frames.forEach((frame) => {
        frame.dataset.compareReady = 'true';
        const range = frame.querySelector('[data-compare-range]');
        if (range) sync(frame, range.value);
        if (io) io.observe(frame);
        else revealFrame(frame);
      });
    };

    document.addEventListener('input', (event) => {
      const range = event.target.closest('[data-compare-range]');
      if (!range) return;
      const frame = range.closest('[data-compare]');
      frame.classList.remove('is-revealing');
      sync(frame, range.value);
    });

    /* lmdh 01/10/2026 : glisser ou toucher n importe ou sur l image. Souris : effet immediat. Doigt :
       le geste devient un glissement des qu il part a l horizontale (touch-action: pan-y laisse le
       defilement vertical a la page) ; un simple toucher place le separateur au doigt. */
    const placer = (frame, clientX) => {
      const r = frame.getBoundingClientRect();
      if (!r.width) return;
      const pct = Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100));
      const range = frame.querySelector('[data-compare-range]');
      if (range) range.value = String(Math.round(pct));
      frame.classList.remove('is-revealing');
      sync(frame, pct);
    };
    let geste = null;
    document.addEventListener('pointerdown', (event) => {
      const frame = event.target.closest('[data-compare]');
      if (!frame || (event.pointerType === 'mouse' && event.button !== 0)) return;
      geste = { frame, id: event.pointerId, x0: event.clientX, y0: event.clientY, actif: event.pointerType === 'mouse', souris: event.pointerType === 'mouse' };
      if (geste.actif) {
        event.preventDefault();
        frame.setPointerCapture?.(event.pointerId);
        placer(frame, event.clientX);
      }
    });
    document.addEventListener('pointermove', (event) => {
      if (!geste || event.pointerId !== geste.id) return;
      if (!geste.actif) {
        const dx = Math.abs(event.clientX - geste.x0);
        const dy = Math.abs(event.clientY - geste.y0);
        if (dy > 10 && dy > dx) { geste = null; return; }
        if (dx > 6 && dx >= dy) {
          geste.actif = true;
          geste.frame.setPointerCapture?.(event.pointerId);
        }
      }
      if (geste && geste.actif) placer(geste.frame, event.clientX);
    });
    const finir = (event) => {
      if (!geste || event.pointerId !== geste.id) return;
      const tap = !geste.actif && !geste.souris && event.type === 'pointerup'
        && Math.abs(event.clientX - geste.x0) < 8 && Math.abs(event.clientY - geste.y0) < 8;
      if (tap) placer(geste.frame, event.clientX);
      geste = null;
    };
    document.addEventListener('pointerup', finir);
    document.addEventListener('pointercancel', finir);

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-compare-tab]');
      if (!tab) return;
      const root = tab.closest('[data-compare-root]');
      if (!root) return;
      const id = tab.getAttribute('data-compare-tab');
      root.querySelectorAll('[data-compare-tab]').forEach((item) => {
        const on = item === tab;
        item.classList.toggle('is-active', on);
        item.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-compare-panel]').forEach((panel) => {
        panel.hidden = panel.getAttribute('data-compare-panel') !== id;
      });
      revealFrame(root.querySelector(`[data-compare-panel="${id}"] [data-compare]`));
    });

    observe(document);
    document.addEventListener('shopify:section:load', (event) => observe(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const wide = window.matchMedia('(min-width: 900px)');
    const groups = () => document.querySelectorAll('.footer details.footer__group');

    const sync = () => {
      groups().forEach((group) => {
        if (wide.matches) {
          group.open = true;
          group.dataset.desktop = 'true';
        } else if (group.dataset.desktop === 'true') {
          group.open = false;
          delete group.dataset.desktop;
        }
      });
    };

    if (!wide.matches) {
      groups().forEach((group) => {
        group.open = false;
      });
    }

    sync();
    wide.addEventListener('change', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    // Recherche mobile : panneau sous la barre.
    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-search-toggle]');
      if (!toggle) return;

      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;

      const open = panel.hasAttribute('hidden');
      panel.toggleAttribute('hidden', !open);
      toggle.setAttribute('aria-expanded', String(open));
      if (open) panel.querySelector('input[type="search"]')?.focus();
    });

    // Recherche desktop : loupe → champ expansible.
    const setupDesktopSearch = (root = document) => {
      root.querySelectorAll('[data-header-search]').forEach((wrap) => {
        if (wrap.dataset.bound === 'true') return;
        wrap.dataset.bound = 'true';

        const toggle = wrap.querySelector('[data-header-search-toggle]');
        const input = wrap.querySelector('input[type="search"]');
        if (!toggle || !input) return;

        const setOpen = (open) => {
          wrap.classList.toggle('is-open', open);
          toggle.setAttribute('aria-expanded', String(open));
          if (open) {
            window.requestAnimationFrame(() => input.focus());
          }
        };

        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          setOpen(true);
        });

        input.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            setOpen(false);
            toggle.focus();
          }
        });

        document.addEventListener('pointerdown', (event) => {
          if (!wrap.classList.contains('is-open')) return;
          if (wrap.contains(event.target)) return;
          setOpen(false);
        });
      });
    };

    setupDesktopSearch();
    document.addEventListener('shopify:section:load', (event) => setupDesktopSearch(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shipping-simulator')) {
    class ShippingSimulator extends HTMLElement {
      connectedCallback() {
        this.threshold = Number(this.dataset.threshold || 85);
        this.giftThreshold = Number(this.dataset.giftThreshold || 0);
        this.shipText = this.dataset.shipText || '';
        this.fee = this.dataset.fee || '3,90 €';
        this.unlockedText = this.dataset.unlockedText || '';
        this.remainingPrefix = this.dataset.remainingPrefix || 'Solo te faltan ';
        this.remainingSuffix = this.dataset.remainingSuffix || '';
        this.feeFree = this.dataset.feeFreeLabel || 'Gratis';
        this.range = this.querySelector('[data-ship-sim-range]');
        this.amountEl = this.querySelector('[data-ship-sim-amount]');
        this.resultEl = this.querySelector('[data-ship-sim-result]');
        this.fillEl = this.querySelector('[data-ship-sim-fill]');
        this.gaugeEl = this.querySelector('[data-ship-sim-gauge]');
        this.feeEl = this.querySelector('[data-ship-sim-fee]');
        if (!this.range) return;
        this.onInput = () => this.update();
        this.range.addEventListener('input', this.onInput);
        this.update();
      }

      disconnectedCallback() {
        if (this.range) this.range.removeEventListener('input', this.onInput);
      }

      fmt(n) {
        const v = Math.max(0, Math.round(Number(n) || 0));
        return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + '\u00a0€';
      }

      update() {
        // lmdh 19/10/2026 (lot BB) : la livraison est offerte au premier seuil, le cadeau au second ; la barre va au second
        const amount = Number(this.range.value) || 0;
        const deuxPaliers = this.giftThreshold > this.threshold;
        const cible = deuxPaliers ? this.giftThreshold : this.threshold;
        const unlocked = amount >= this.threshold;
        const cadeau = deuxPaliers ? amount >= this.giftThreshold : unlocked;
        const pct = Math.min(100, Math.round((amount / cible) * 100));
        const remaining = Math.max(0, this.threshold - amount);

        this.amountEl.textContent = this.fmt(amount);
        this.range.setAttribute('aria-valuenow', String(amount));
        this.fillEl.style.width = pct + '%';
        this.gaugeEl.setAttribute('aria-valuenow', String(pct));
        this.classList.toggle('is-unlocked', unlocked);
        this.feeEl.textContent = unlocked ? this.feeFree : this.fee;
        this.resultEl.textContent = cadeau
          ? this.unlockedText
          : unlocked && this.shipText
            ? this.shipText.replace('__amount__', this.fmt(this.giftThreshold - amount))
            : this.remainingPrefix + this.fmt(remaining) + this.remainingSuffix;
      }
    }
    customElements.define('shipping-simulator', ShippingSimulator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  const toEmbedUrl = (raw) => {
    try {
      const parsed = new URL(raw, window.location.origin);
      const host = parsed.hostname.replace(/^www\./, '');
      const parts = parsed.pathname.split('/').filter(Boolean);

      if (host === 'youtu.be' && parts[0]) {
        return `https://www.youtube.com/embed/${parts[0]}`;
      }
      if (host.includes('youtube.com')) {
        const id = parsed.searchParams.get('v') || parts.filter((part) => part !== 'embed' && part !== 'shorts').pop();
        return id ? `https://www.youtube.com/embed/${id}` : raw;
      }
      if (host.includes('vimeo.com')) {
        const id = host === 'player.vimeo.com' ? parts[parts.length - 1] : parts[0];
        if (!id) return raw;
        const hash = host === 'player.vimeo.com' ? parsed.searchParams.get('h') : parts[1];
        const embed = `https://player.vimeo.com/video/${id}`;
        return hash ? `${embed}?h=${hash}` : embed;
      }
    } catch (error) {
      return raw;
    }
    return raw;
  };

  document.addEventListener('click', (event) => {
    const facade = event.target.closest('[data-video-facade]');
    if (!facade) return;

    const url = facade.dataset.videoUrl;
    if (!url) return;

    const embed = toEmbedUrl(url);
    const iframe = document.createElement('iframe');
    iframe.src = embed.includes('?') ? `${embed}&autoplay=1` : `${embed}?autoplay=1`;
    iframe.title = facade.getAttribute('aria-label') || '';
    iframe.allow = 'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;

    facade.replaceWith(iframe);
    iframe.focus();
  });

  } catch(e) { console.error(e); }
})();
})();
